import {useAppContext} from "../utils/AppContext";
import {support_en} from "../assets/texts/en";
import Footer from "../components/home/Footer";

const Privacy = () => {
    const {
        screenSize,
    } = useAppContext();

    const contentContainer = (!screenSize)? "content-container" : `content-container content-container${screenSize}`;
    const supportScroll = (!screenSize)? "support-pages-scroll" : `support-pages-scroll support-pages-scroll${screenSize}`;
    const termsContainer = (!screenSize)? "terms-container" : `terms-container terms-container${screenSize}`;
    const sectionTitle = (!screenSize)? 'section-title' : `section-title section-title${screenSize}`;
    const supportPageHeader = (!screenSize)? 'support-page-header' : `support-page-header support-page-header${screenSize}`;
    const supportItemContainer = (!screenSize)? 'support-item-container' : `support-item-container support-item-container${screenSize}`;
    const itemTitle = (!screenSize)? 'item-title' : `item-title item-title${screenSize}`;
    const regularTextLight = (!screenSize)? 'regular-text-light' : `regular-text-light regular-text-light${screenSize}`;
    const smallTextLight = (!screenSize)? 'small-text-light' : `small-text-light small-text-light${screenSize}`;
    const footerItemsContainer = (!screenSize)? "footer-items-container" : `footer-items-container footer-items-container${screenSize}`;

    return (
        <div className={contentContainer}>
            <div className={supportScroll}>
                <div className={termsContainer}>
                    <div className={supportPageHeader}>
                        <h2 className={sectionTitle}>{support_en.privacy.title}</h2>
                        <span className={smallTextLight}>{support_en.privacy.date}</span>
                    </div>
                    <div className={supportItemContainer}>
                        <p className={smallTextLight}>Maze respects your privacy and is committed to protecting your personal information. This Privacy Policy describes how we collect, use, disclose, and protect your information when you use our website and app ("Services"). By accessing or using our Services, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy.</p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>1. Information We Collect</h2>
                        <p className={smallTextLight}>We collect various types of information to provide and improve our Services:
                        </p>
                        <h2 className={regularTextLight}>1.1. Personal Information:</h2>
                        <p className={smallTextLight}>
                            <strong>Name and Email:</strong> We collect your name and email address if you choose to provide them, for example, when you create an account or interact with our services.<br/>
                            <strong>User Preferences:</strong> We save your preferences to personalize your experience and tailor content.<br/>
                            <strong>Transactional Information:</strong> We collect information about your transactions, such as the services you purchase and the payment method you use.<br/>
                            <strong>Business Information:</strong> We may collect information about your business, such as your company name, industry, and website.
                        </p>
                    </div> 
                    <div className={supportItemContainer}> 
                        <h2 className={regularTextLight}>1.2. Non-Personal Information:</h2>
                        <p className={smallTextLight}>
                            <strong>IP Addresses:</strong> We temporarily collect IP addresses for security and operational purposes.<br/>
                            <strong>Chat Transcripts:</strong> We temporarily save chat transcripts to provide and improve our chat services.<br/>
                            <strong>Cookies and Similar Technologies:</strong> We use cookies and similar technologies to collect information about your use of the Services. This information may include your browser type, device type, operating system, referring URLs, and pages viewed.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>2. How We Use Your Information</h2>
                        <p className={smallTextLight}>We use the information we collect solely to:<br/>
                            • Provide, operate, and improve the Services, including generating copywriting, facilitating chat conversations, and delivering personalized content.<br/>
                            • Tailor content and personalize your experience.<br/>
                            • Process your transactions.<br/>
                            • Send you marketing communications, with your consent.<br/>
                            • Respond to your inquiries and provide customer support.<br/>
                            • Analyze and understand how the Services are used.<br/>
                            • Detect and prevent fraud and abuse.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>3. Disclosure of Your Information</h2>
                        <p className={smallTextLight}>We may disclose your information:<br/>
                            • To service providers who assist us in providing the Services.<br/>
                            • To comply with legal obligations or requests from law enforcement.<br/>
                            • To protect the rights, property, or safety of Maze, our users, or others.<br/>
                            • We do not share your data with anyone nor sell it to third parties.<br/>
                            • Your conversations are not shared nor sold to third parties.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>4. Data Security</h2>
                        <p className={smallTextLight}>We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, and destruction. However, no method of transmission over the Internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee the absolute security of your information.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>5. Your Privacy Choices</h2>
                        <p className={smallTextLight}>You can opt-out of receiving marketing communications from us by following the unsubscribe instructions provided in the communications. You can also manage your cookie preferences through your web browser settings.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>6. Children's Privacy</h2>
                        <p className={smallTextLight}>The Services are not intended for children under the age of 13. We do not knowingly collect personal information from children under the age of 13.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>7. Changes to this Privacy Policy</h2>
                        <p className={smallTextLight}>We may update this Privacy Policy from time to time. We will post any changes on this page and update the "Last Updated" date at the top of the policy.
                        </p>
                    </div>
                    <div className={supportItemContainer}>
                        <h2 className={itemTitle}>8. Contact Us</h2>
                        <p className={smallTextLight}>If you have any questions about this Privacy Policy, please contact us at hello@maze.do
                        </p>
                    </div>
                </div>
                <div className={footerItemsContainer}>
                    <Footer/>
                </div>
            </div>
        </div>
    );

};

export default Privacy;
